export const DIRECTORY_CAPABILITIES = [
  {
    id: 'employee-grid',
    label: 'Employee grid',
    role: 'primary directory surface',
    feeds: ['daily-entry', 'scheduler', 'fleet', 'scorecards'],
  },
  {
    id: 'detail-cards',
    label: 'Detail cards',
    role: 'employee source of truth',
    feeds: ['payroll', 'permissions', 'onboarding'],
  },
  {
    id: 'pending-registrations',
    label: 'Pending registrations',
    role: 'identity intake seam',
    feeds: ['onboarding', 'directory approval flow'],
  },
  {
    id: 'edit-log',
    label: 'Edit log',
    role: 'audit and accountability seam',
    feeds: ['payroll', 'hr review', 'operator trust'],
  },
  {
    id: 'employee-assets',
    label: 'Employee assets',
    role: 'assignment and accountability seam',
    feeds: ['fleet', 'offboarding'],
  },
];
